export const wordpressBaseUrl = (): string => {
  return "https://pococare.com";
};
